import {
    Box,
    Button,
    createStyles,
    Divider,
    ExpansionPanel,
    ExpansionPanelActions,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Grid,
    Hidden,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    withStyles,
    withWidth,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment";
import React from "react";
import { formatRupiah } from "../../../components/Utils/Utils";

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            width: "100%",
        },
        paper1: {
            marginTop: 15,
            backgroundColor: theme.palette.background.paper,
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
        },
        secondaryHeading: {
            fontSize: theme.typography.pxToRem(15),
            color: theme.palette.text.secondary,
        },
    })
);

const TableCellHead = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
}))(TableCell);

const TableCellBodyBold = withStyles((theme) => ({
    body: {
        fontWeight: "bolder",
    },
}))(TableCell);

const Panel = React.memo(
    ({
        collapsePanel,
        handleUpdateProgress,
        id,
        expanded,
        width,
        transaction,
        action,
    }) => {
        const classes = useStyles();
        const order = transaction.orders[0];
        const tenant = order.tenant;

        return (
            <ExpansionPanel
                expanded={expanded === `panel${id}`}
                onChange={collapsePanel(`panel${id}`)}
            >
                <ExpansionPanelSummary
                    aria-controls={`panel${id}-content`}
                    id={`panel${id}-header`}
                >
                    <Grid
                        item
                        xs={width === "sm" || width === "xs" || width === "md" ? 4 : 2}
                    >
                        <Typography className={classes.secondaryHeading}>Name</Typography>
                        <Typography className={classes.heading}>
                            {transaction.user.name || "Buyer"}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={width === "sm" || width === "xs" || width === "md" ? 4 : 2}
                    >
                        <Typography className={classes.secondaryHeading}>Mall</Typography>
                        <Typography className={classes.heading}>
                            {tenant.property.name || ""}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={width === "sm" || width === "xs" || width === "md" ? 4 : 2}
                    >
                        <Typography className={classes.secondaryHeading}>Tenant</Typography>
                        <Typography className={classes.heading}>
                            {tenant.name || ""}
                        </Typography>
                    </Grid>
                    <Hidden mdDown>
                        <Grid item xs={2}>
                            <Typography className={classes.secondaryHeading}>
                                Billing
                </Typography>
                            <Typography className={classes.heading}>
                                {formatRupiah(
                                    order.items[0].price.currency,
                                    order.sub_total_amount.toString()
                                )}
                            </Typography>
                        </Grid>
                    </Hidden>
                    <Hidden mdDown>
                        <Grid item xs={4}>
                            <Typography className={classes.secondaryHeading}>Date</Typography>
                            <Typography className={classes.heading}>
                                {moment(transaction.create_time).format(
                                    "MMM Do YYYY, h:mm:ss a"
                                )}
                            </Typography>
                        </Grid>
                    </Hidden>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box margin={1} style={{ width: "100%" }}>
                        <Table size="small" aria-label="detail order">
                            <TableHead>
                                <TableRow>
                                    <TableCellHead>Item</TableCellHead>
                                    <TableCellHead>Qty</TableCellHead>
                                    <TableCellHead align="right">Price</TableCellHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {order.items
                                    ? order.items.map((item, i) => {
                                        return (
                                            <TableRow>
                                                <TableCell>{item.name || ""}</TableCell>
                                                <TableCell>
                                                    {item.qty} x (
                              {formatRupiah(
                                                        item.price.currency,
                                                        item.price.value.toString()
                                                    )}
                              )
                            </TableCell>
                                                <TableCell align="right">
                                                    {formatRupiah(
                                                        item.price.currency,
                                                        (item.qty * item.price.value).toString()
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                    : ""}
                                <TableRow>
                                    <TableCellBodyBold colSpan={2}>Sub Total</TableCellBodyBold>
                                    <TableCellBodyBold align="right">
                                        {formatRupiah(
                                            order.items[0].price.currency,
                                            (
                                                order.sub_total_amount -
                                                order.service_charge_amount -
                                                order.tax_charge_amount
                                            ).toString()
                                        )}
                                    </TableCellBodyBold>
                                </TableRow>
                                <TableRow>
                                    <TableCellBodyBold colSpan={2}>
                                        Service ({order.service_charge_percentage}%)
                    </TableCellBodyBold>
                                    <TableCellBodyBold align="right">
                                        {formatRupiah(
                                            order.items[0].price.currency,
                                            order.service_charge_amount.toString()
                                        )}
                                    </TableCellBodyBold>
                                </TableRow>
                                <TableRow>
                                    <TableCellBodyBold colSpan={2}>
                                        Tax ({order.tax_charge_percentage}%)
                    </TableCellBodyBold>
                                    <TableCellBodyBold align="right">
                                        {formatRupiah(
                                            order.items[0].price.currency,
                                            order.tax_charge_amount.toString()
                                        )}
                                    </TableCellBodyBold>
                                </TableRow>
                                <TableRow>
                                    <TableCellBodyBold
                                        colSpan={3}
                                        align="right"
                                        style={{ borderBottom: "none", fontSize: "larger" }}
                                    >
                                        Total:{" "}
                                        {formatRupiah(
                                            order.items[0].price.currency,
                                            (order.sub_total_amount || 0).toString()
                                        )}
                                    </TableCellBodyBold>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </ExpansionPanelDetails>
                <Divider />
                {action.status_action && (
                    <ExpansionPanelActions>
                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() => handleUpdateProgress(order, action)}
                        >
                            {action.label_action}
                        </Button>
                    </ExpansionPanelActions>
                )}
            </ExpansionPanel>
        );
    }
);

const PanelLoading = ({ id, width }) => {
    return (
        <ExpansionPanel>
            <ExpansionPanelSummary
                aria-controls={`panel${id}-content`}
                id={`panel${id}-header`}
            >
                <Grid
                    item
                    xs={width === "sm" || width === "xs" || width === "md" ? 4 : 2}
                >
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={width === "sm" || width === "xs" || width === "md" ? 40 : 60}
                    />
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={
                            width === "sm" || width === "xs" || width === "md" ? 80 : 100
                        }
                    />
                </Grid>
                <Grid
                    item
                    xs={width === "sm" || width === "xs" || width === "md" ? 4 : 2}
                >
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={width === "sm" || width === "xs" || width === "md" ? 40 : 60}
                    />
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={
                            width === "sm" || width === "xs" || width === "md" ? 80 : 100
                        }
                    />
                </Grid>
                <Grid
                    item
                    xs={width === "sm" || width === "xs" || width === "md" ? 4 : 2}
                >
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={width === "sm" || width === "xs" || width === "md" ? 40 : 60}
                    />
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={
                            width === "sm" || width === "xs" || width === "md" ? 80 : 100
                        }
                    />
                </Grid>
                <Hidden mdDown>
                    <Grid item xs={2}>
                        <Skeleton variant="text" animation="wave" width={60} />
                        <Skeleton variant="text" animation="wave" width={100} />
                    </Grid>
                </Hidden>
                <Hidden mdDown>
                    <Grid item xs={4}>
                        <Skeleton variant="text" animation="wave" width={60} />
                        <Skeleton variant="text" animation="wave" width={100} />
                    </Grid>
                </Hidden>
            </ExpansionPanelSummary>
        </ExpansionPanel>
    );
};

const PanelExport = ({ transactions }) => {
    return (
        <table id="tableExport" style={{ display: "none" }}>
            <thead>
                <tr>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Name
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Mall
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Tenant
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Date
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        colSpan={3}
                    >
                        Item
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Sub Total
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Service (
              {transactions[0].orders[0].tenant.service_charge_percentage}%)
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Tax ({transactions[0].orders[0].tenant.tax_charge_percentage}%)
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                        rowSpan={2}
                    >
                        Total
            </td>
                </tr>
                <tr>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                    >
                        Item Name
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                    >
                        Qty
            </td>
                    <td
                        style={{
                            border: "1px solid #000000",
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            fontWeight: "bolder",
                            verticalAlign: "middle",
                        }}
                        valign="middle"
                        align="center"
                    >
                        Price
            </td>
                </tr>
            </thead>
            <tbody>
                {transactions.map((transaction, keyTransaction) => {
                    return (
                        <React.Fragment>
                            <tr>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {transaction.user.name || "Buyer"}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {transaction.orders[0].tenant.property.name || ""}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {transaction.orders[0].tenant.name || ""}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {moment(transaction.create_time).format(
                                        "MMM Do YYYY, h:mm:ss a"
                                    )}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "thin",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    align="left"
                                >
                                    {transaction.orders[0].items[0].name || ""}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "thin",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    align="left"
                                >
                                    {transaction.orders[0].items[0].qty} x (
                    {formatRupiah(
                                        transaction.orders[0].items[0].price.currency,
                                        transaction.orders[0].items[0].price.value.toString()
                                    )}
                    )
                  </td>
                                <td
                                    style={{
                                        fontWeight: "thin",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    align="right"
                                >
                                    {formatRupiah(
                                        transaction.orders[0].items[0].price.currency,
                                        (
                                            transaction.orders[0].items[0].qty *
                                            transaction.orders[0].items[0].price.value
                                        ).toString()
                                    )}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {formatRupiah(
                                        transaction.orders[0].items[0].price.currency,
                                        (
                                            transaction.orders[0].sub_total_amount -
                                            transaction.orders[0].service_charge_amount -
                                            transaction.orders[0].tax_charge_amount
                                        ).toString()
                                    )}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {formatRupiah(
                                        transaction.orders[0].items[0].price.currency,
                                        transaction.orders[0].service_charge_amount.toString()
                                    )}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {formatRupiah(
                                        transaction.orders[0].items[0].price.currency,
                                        transaction.orders[0].tax_charge_amount.toString()
                                    )}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "normal",
                                        border: "1px solid #000000",
                                        verticalAlign: "top",
                                    }}
                                    rowSpan={transaction.orders[0].items.length}
                                >
                                    {formatRupiah(
                                        transaction.orders[0].items[0].price.currency,
                                        (transaction.orders[0].sub_total_amount || 0).toString()
                                    )}
                                </td>
                            </tr>
                            {transaction.orders[0].items.length > 1 &&
                                transaction.orders[0].items
                                    .filter((item, itemKey) => itemKey !== 0)
                                    .map((item, keyItem) => {
                                        return (
                                            <tr>
                                                <td
                                                    style={{
                                                        fontWeight: "thin",
                                                        border: "1px solid #000000",
                                                        verticalAlign: "top",
                                                    }}
                                                    align="left"
                                                >
                                                    {item.name || ""}
                                                </td>
                                                <td
                                                    style={{
                                                        fontWeight: "thin",
                                                        border: "1px solid #000000",
                                                        verticalAlign: "top",
                                                    }}
                                                    align="left"
                                                >
                                                    {item.qty} x (
                            {formatRupiah(
                                                        item.price.currency,
                                                        item.price.value.toString()
                                                    )}
                            )
                          </td>
                                                <td
                                                    style={{
                                                        fontWeight: "thin",
                                                        border: "1px solid #000000",
                                                        verticalAlign: "top",
                                                    }}
                                                    align="right"
                                                >
                                                    {formatRupiah(
                                                        item.price.currency,
                                                        (item.qty * item.price.value).toString()
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                        </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
};

const ListPanel = withWidth()(Panel);
const ListPanelLoading = withWidth()(PanelLoading);

export { ListPanel, ListPanelLoading, PanelExport };
